export default class City {
  constructor(API) {
    this.api = API;
  }
  async getAllLocations() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/locations';
    return await req.exec();
  }
}